export default "__VITE_ASSET__DrIol3lx__"